module.exports = __webpack_public_path__ + "img/user.7eeada09.svg";